const orderStatusMap = {
  pending: { label: 'Pending', className: 'badge-outline' },
  confirmed: { label: 'Confirmed', className: 'badge-secondary' },
  shipped: { label: 'Shipped', className: 'badge-primary' },
  out_for_delivery: { label: 'Out for Delivery', className: 'badge-primary' },
  delivered: { label: 'Delivered', className: 'badge-success' },
  cancelled: { label: 'Cancelled', className: 'badge-danger' },
};

export function OrderStatusBadge({ status }) {
  const config = orderStatusMap[status] || { label: status, className: 'badge-outline' };
  return <span className={`badge ${config.className}`}>{config.label}</span>;
}

export function StockBadge({ inStock }) {
  return (
    <span className={`badge ${inStock ? 'badge-success' : 'badge-danger'}`}>
      {inStock ? 'In Stock' : 'Out of Stock'}
    </span>
  );
}

export function ActiveBadge({ active }) {
  return (
    <span className={`badge ${active ? 'badge-success' : 'badge-secondary'}`}>
      {active ? 'Active' : 'Inactive'}
    </span>
  );
}

export function RoleBadge({ role }) {
  return (
    <span className={`badge ${role === 'admin' ? 'badge-primary' : 'badge-outline'}`}>
      {role === 'admin' ? 'Admin' : 'Customer'}
    </span>
  );
}

export function FeaturedBadge({ featured }) {
  if (!featured) return null;
  return <span className="badge badge-secondary">Featured</span>;
}
